// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2fn6w","row":"ProcedureTreatmentSummary_row__kJrtP"};